import axios from 'axios'

let instance = axios.create({
  baseURL: `${process.env.VUE_APP_BE_WELL_CMS_URL}/api`,
  timeout: 30000
})
const defaultParams = {
  "filter[visibility:in]" : 'community_wealth_builder_no_public|community_wealth_builder_yes_public'
}
export default {
  index (collection, params = {}) {
    return instance({
      url: `collections/${collection}/entries`,
      method: 'GET',
      params : {...defaultParams, ...params}
    })
  },
  show (collection,id) {
    return instance({
      url: `collections/${collection}/entries/${id}`,
      method: 'GET'
    })
  },
}
